/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DocumentTimeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <circle cx="17.5" cy="17.5" r="6" />
      <polyline points="20 18.5 17.5 18.5 17.5 15" />
      <path d="M3.5,6.5 L8,6.5" />
      <path d="M3.5,9.5 L11.5,9.5" />
      <path d="M3.5,12.5 L9.5,12.5" />
      <path d="M3.5,15.5 L8.5,15.5" />
      <polyline points="10.5 21.5 0.5 21.5 0.5 0.5 11.5 0.5 16.5 5.5 16.5 9.5" />
      <polyline points="11.5 0.5 11.5 5.5 16.5 5.5" />
    </g>
  </svg>
);

export default DocumentTimeIcon;
